import axios from 'axios';

// Configure axios defaults for authentication
axios.defaults.withCredentials = true;

// Backend server serves routes under /api; total-sales router is mounted at /api/total-sales
const BASE_API = process.env.REACT_APP_API_URL;
const SALES_BASE = `${BASE_API}/total-sales`;

class SalesService {
  static async createSale(saleData) {
    try {
      const fullUrl = `${SALES_BASE}/sales/create`;

      // Get auth token from localStorage
      const token = localStorage.getItem('token') || localStorage.getItem('authToken');
      
      if (!token) {
        console.error('❌ No authentication token found!');
        throw new Error('Authentication required. Please log in.');
      }
      
      const response = await axios.post(fullUrl, saleData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` // Add JWT token
        },
        withCredentials: true, // Include session cookies for authentication
        timeout: 120000 // 120 second timeout
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ Error creating sale:', error);
      console.error('❌ Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        url: error.config?.url
      });
      throw error.response?.data || error;
    }
  }

  static async preCheckStock(checkData) {
    try {
      const fullUrl = `${SALES_BASE}/sales/pre-check-stock`;

      // Get auth token from localStorage
      const token = localStorage.getItem('token') || localStorage.getItem('authToken');
      
      if (!token) {
        console.error('❌ No authentication token found!');
        throw new Error('Authentication required. Please log in.');
      }
      
      const response = await axios.post(fullUrl, checkData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        withCredentials: true,
        timeout: 120000 // 120 second timeout for stock check (batched queries, but safety margin for large menus)
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ Error checking stock:', error);
      console.error('❌ Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        url: error.config?.url
      });
      throw error.response?.data || error;
    }
  }

  static async getTotalSalesReport(params) {
    try {
      // Get auth token from localStorage
      const token = localStorage.getItem('token') || localStorage.getItem('authToken');
      
      const response = await axios.get(`${SALES_BASE}/sales/total-report`, { 
        params,
        headers: token ? {
          'Authorization': `Bearer ${token}`
        } : {},
        withCredentials: true // Include session cookies for authentication
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  static async recordSubstitute(substituteData) {
    try {
      const fullUrl = `${SALES_BASE}/record-substitute`;

      
      const token = localStorage.getItem('token') || localStorage.getItem('authToken');
      
      if (!token) {
        console.error('❌ No authentication token found!');
        throw new Error('Authentication required. Please log in.');
      }
      
      const response = await axios.post(fullUrl, substituteData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        withCredentials: true,
        timeout: 15000
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ Error recording substitute:', error);
      console.error('❌ Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        url: error.config?.url
      });
      throw error.response?.data || error;
    }
  }

  static async removeFromRecipe(removalData) {
    try {
      const fullUrl = `${SALES_BASE}/sales/remove-from-recipe`;

      
      const token = localStorage.getItem('token') || localStorage.getItem('authToken');
      
      if (!token) {
        console.error('❌ No authentication token found!');
        throw new Error('Authentication required. Please log in.');
      }
      
      const response = await axios.post(fullUrl, removalData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        withCredentials: true,
        timeout: 15000
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ Error removing from recipe:', error);
      console.error('❌ Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        url: error.config?.url
      });
      throw error.response?.data || error;
    }
  }
}

export default SalesService;